<template>
  <div id="dashboard" class="bgrojo">
    <section class="bannerprincipal">
      <div class="">
        <div class="row">
          <div class="col-12 col-md-12 offset-md-0 h-100 py-5">
            <div class="py-4 pt-5 py-md-0">
              <div
                class="d-flex justify-content-center align-items-center fanta amarillo fXG"
              >
                &nbsp;
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="">
      <div class="row py-5">
        <div class="col-lg-6 d-none d-lg-block">
          <img
            src="../assets/imgs/verano23/mnms-verano.png"
            alt="Verano Cinépolis"
            class="w-100"
          />
        </div>
        <div class="col-lg-6 pt-3 pb-0">
          <!-- <p class="fXG text-center bold pb-4 blanco">
            ¡Hola
            <span class="blanco">{{ userProfile.nombre }}</span
            >!
          </p> -->

          <p class="fXXXG text-center blanco fanta">
            SUBE TU <br />
            TICKET
          </p>

          <div class="row">
            <div
              class="col-12 text-center d-flex justify-content-center align-items-center"
            >
              <input
                type="file"
                class="hidden"
                ref="file"
                @change="fileSelected"
                accept="image/*"
                capture
              />
            </div>

            <div class="col-12 py-2">
              <div class="px-2 row">
                <form class="col-12 text-left">
                  <div class="row">
                    <div class="col-12 pb-3">
                      <div class="row">
                        <!-- <div class="col-12 fG bold pb-2 blanco">
                      
                      <span class="iconoinfo" @click="toggleInfoMonto()">
                        <svg
                          height="24"
                          viewBox="0 0 48 48"
                          width="24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M22 34h4v-12h-4v12zm2-30c-11.05 0-20 8.95-20 20s8.95 20 20 20 20-8.95 20-20-8.95-20-20-20zm0 36c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16zm-2-22h4v-4h-4v4z"
                          />
                        </svg>
                      </span>
                    </div> -->

                        <!-- <div class="col-12 text-center" v-show="info_monto">
                      <img
                        class="img-fluid"
                        src="../assets/imgs/viaja/interior/ticket_sumar_monto.png"
                        alt="Verano con sabor a cinepolis"
                      />
                    </div> -->
                      </div>
                      <!-- <label class="px-2">
                    <input
                      type="number"
                      required
                      v-model="monto"
                      placeholder="Monto de compra en productos"
                    />
                  </label> -->
                    </div>
                    <!-- <div class="col-12">
                  <div class="row fG bold pb-2 blanco">
                    <div class="col-12">
                      No. de Ticket

                      <span class="iconoinfo" @click="toggleInfoTicket()">
                        <svg
                          height="24"
                          viewBox="0 0 48 48"
                          width="24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M22 34h4v-12h-4v12zm2-30c-11.05 0-20 8.95-20 20s8.95 20 20 20 20-8.95 20-20-8.95-20-20-20zm0 36c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16zm-2-22h4v-4h-4v4z"
                          />
                        </svg>
                      </span>
                    </div>
                    <div class="col-12 text-center" v-show="info_ticket">
                      <img
                        class="img-fluid"
                        src="../assets/imgs/viaja/interior/ticket_numero_de_ticket.png"
                        alt="Verano con sabor a cinepolis"
                      />
                    </div>
                  </div>
                  <label class="px-2">
                    <input
                      type="text"
                      required
                      v-model="no_ticket"
                      placeholder="No. de Ticket"
                      maxlength="30"
                    />
                  </label>
                </div> -->
                  </div>
                </form>
              </div>
            </div>

            <div class="col-12 pb-3 px-5 text-center">
                <span class="small fanta blanco">Recuerda que solo participan tickets de compra que hayan sido emitidos durante la vigencia de la promoción.</span>
                
              </div>

            <div class="w-100 text-center pr-lg-4">

              


              <div class="px-2 text-center d-inline-block align-items-center  pb-5">
                <button
                  @click="$refs.file.click()"
                  class="btnaction2 pointer d-inline-block align-items-center justify-content-center fXG2 fanta"
                >
                  SUBIR TICKET
                </button>
              </div>

              <div class="py-3">
                <div id="preview"></div>
              </div>

             

              <!-- <div class="col-12 pb-5 px-5">
                <form action @submit.prevent>
                  
                  <label for class="py-4">
                    <span class="mb-3 fG fanta blanco"
                      >Ingresa tu membresía Club Cinépolis para obtener más puntos:</span
                    >
                    
                    <input
                      type="number"
                      class="text-center"
                      v-model.trim="socio"
                      max="99999999999999999999999"
                      placeholder="Membresía Club Cinépolis "
                    />
                  </label>
                </form>
              </div> -->

              <div class="col-12 pb-5" v-if="file != null">
                <div class="px-2 text-center d-flex align-items-center">
                  <button
                    @click="tomarParticipacion()"
                    class="btnaction pointer d-inline-block align-items-center justify-content-center fXG2 ml-auto mr-auto fanta"
                  >
                    ENVIAR FOTO
                  </button>
                </div>
              </div>

              <div class="col-12">
                <div class="text-center pb-5">
                  <router-link
                    to="/mis-participaciones"
                    class="pointer d-inline-block align-items-center justify-content-center fXG2 ml-auto mr-auto btnaction3 fanta"
                  >
                    MIS PUNTOS
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>

    <!-- <div class="hidden" v-for="(img) in disponibles" :key="img">
      <img
       rel="preload"
        :src="require('../assets/imgs/juego/matches/' + img + '-1.png')"
        alt="flecha"
      />
      <img
       rel="preload"
        :src="require('../assets/imgs/juego/matches/' + img + '-2.png')"
        alt="flecha"
      />
    </div>
    <div class="hidden" v-for="(img) in dulceria" :key="img">
      <img
       rel="preload"
        :src="require('../assets/imgs/juego/matches/' + img + '-1.png')"
        alt="flecha"
      />
      <img
       rel="preload"
        :src="require('../assets/imgs/juego/matches/' + img + '-2.png')"
        alt="flecha"
      />
    </div> -->

    <div
      class="overlayticket overlay-sucursal"
      v-if="overlay_sucursal === true"
    >
      <div class="bg-overlay" @click="toggleSucursal"></div>
      <div class="ticket shadow rounded bg-moradooscuro">
        <div class="head">
          <div
            class="cerrar p-2 d-block fG pointer amarillo monts"
            @click="toggleSucursal"
          >
            cerrar
          </div>
        </div>
        <div class="body text-center w-100"></div>
      </div>
    </div>

    <div
      class="overlayticket overlay-sucursal"
      v-if="overlay_transaccion === true"
    >
      <div class="bg-overlay" @click="toggleTransaccion"></div>
      <div class="ticket shadow rounded bg-moradooscuro">
        <div class="head">
          <span
            class="cerrar p-2 d-block fG pointer amarillo monts"
            @click="toggleTransaccion"
            >cerrar</span
          >
        </div>
        <div class="body text-center w-100">
          <div class="titulo fG amarillo bold">Número de transacción:</div>
          <img
            class="img-fluid p-4"
            src="../assets/imgs/homeins/ticket-transaccion.jpg"
            alt="Verano con sabor a cinepolis"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commentsCollection, ticketsCollection } from "@/firebase";
import { mapState } from "vuex";
import moment from "moment";
import AOS from "aos";
import swal from "sweetalert2";

import * as fb from "../firebase";

import Footer from "@/components/Footer";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      post: {
        content: "",
      },
      showCommentModal: false,
      selectedPost: {},
      showPostModal: false,
      fullPost: {},
      postComments: [],
      file: null,
      file2: null,
      file3: null,
      no_ticket: "",
      monto: null,
      no_membresia_plus: "",
      cadena: "Sams",
      monto_minimo: 100,
      monedero: "",
      no_transaccion: null,
      no_sucursal: null,
      disponibles: [
        "merida",
        "fantasma",
        "forrest",
        "gladiador",
        "id4",
        "lalaland",
        "malefica",
        "parque-jurasico",
        "psicosis",
        "pulp",
        "et",
        "chucky",
        "diario",
        "wolverine",
        "piratas",
        "peterpan",
        "titanic",
        "lord",
        "karate",
        "silencio",
        "kill",
        "godfather",
        "resplandor",
        "mary",
        "mago",
        "blackpanther",
        "corazon",
        "inception",
        "harry",
        "simpsons",

        "aladino",
        "alicia",
        "alien",
        "ava",
        "baby",
        "batman",
        "bella",
        "ben",
        "big",
        "blancanieves",

        "buscando",
        "capitan",
        "car",
        "cenicienta",
        "coco",
        "dama",
        "dirty",
        "dracula",
        "emperor",
        "escuadron",

        "exorcista",
        "froz",
        "hombres",
        "home",
        "hunger",
        "ice",
        "increibles",
        "indiana",
        "iron",
        "it",

        "kung",
        "lilo",
        "mati",
        "matrix",
        "mega",
        "mision",
        "moa",
        "monsters",
        "mulan",
        "naufrago",

        "nosotros",
        "pesadilla",
        "picapiedra",
        "pino",
        "poca",
        "quien",
        "quinto",
        "rapsodia",
        "rata",
        "reyleon",

        "rock",
        "sabueso",
        "scooby",
        "shrek",
        "sirenita",
        "spiderman",
        "starwars",
        "super",
        "tarzan",
        "termi",

        "thor",
        "tiburon",
        "tomb",
        "top",
        "toy",
        "trans",
        "up",
        "vase",
        "villano",
        "volver",

        "wall",
        "wonder",
      ],
      dulceria: [
        "dulceria1",
        "dulceria2",
        "dulceria3",
        "dulceria4",
        "dulceria5",
        "dulceria6",
        "dulceria7",
        "dulceria8",
        "dulceria9",
        "dulceria10",
        "dulceria11",
      ],
      overlay_transaccion: false,
      overlay_sucursal: false,
      info_monto: false,
      info_ticket: false,
      socio_plus: false,
      tickets3: null,
      ultimo_ticket: {
        puntos: "",
        time: "",
        time_txt: "",
      },
      tokens_disponibles: 0,
    };
  },
  computed: {
    ...mapState(["userProfile", "posts"]),
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation,
      disable: "mobile",
    });

    this.getTickets2();
  },
  methods: {
    // async jugar() {
    //   this.$store.commit(
    //     "setTicketID",
    //     this.userProfile.ultimo_ticket_registrado
    //   );
    //   this.$router.push("/dinamica");
    // },
    async getTickets2() {
      const docs = await ticketsCollection
        .where("user_id", "==", fb.auth.currentUser.uid)
        .where("status_juego", "==", "jugando")
        .get();

      this.tickets3 = [];
      docs.forEach((doc) => {
        let ticket = doc.data();
        ticket.id = doc.id;
        this.tickets3.push(ticket);

        this.tokens_disponibles += ticket.tokens_disponibles;
      });

      console.log({ tickets3: this.tickets3 });
    },

    toggleInfoMonto() {
      this.info_monto = !this.info_monto;
    },
    toggleInfoTicket() {
      this.info_ticket = !this.info_ticket;
    },
    fileSelected: function ($event) {
      this.file = $event.target.files[0];

      var reader = new FileReader();

      reader.onload = function (e) {
        // get loaded data and render thumbnail.
        var preview = document.getElementById("preview");
        var image = document.createElement("img");
        image.src = e.target.result;
        preview.innerHTML = "";
        preview.appendChild(image);
        console.log(preview);

        swal.fire(
          "Bien",
          "Recuerda conservar tus tickets de compra, da clic en jugar para participar.",
          "warning"
        );
      };

      // read the image file as a data URL.
      reader.readAsDataURL(this.file);
    },
    fileSelected2: function ($event) {
      this.file2 = $event.target.files[0];

      var reader = new FileReader();

      reader.onload = function (e) {
        // get loaded data and render thumbnail.
        var preview = document.getElementById("preview2");
        var image = document.createElement("img");
        image.src = e.target.result;
        preview.innerHTML = "";
        preview.appendChild(image);
        console.log(preview);
      };

      // read the image file as a data URL.
      reader.readAsDataURL(this.file2);
    },
    fileSelected3: function ($event) {
      this.file3 = $event.target.files[0];

      var reader = new FileReader();

      reader.onload = function (e) {
        // get loaded data and render thumbnail.
        var preview = document.getElementById("preview3");
        var image = document.createElement("img");
        image.src = e.target.result;
        preview.innerHTML = "";
        preview.appendChild(image);
        console.log(preview);
      };

      // read the image file as a data URL.
      reader.readAsDataURL(this.file3);
    },
    async tomarParticipacion() {
      if (this.file == null) {
        swal.fire(
          "Oops",
          "Sube la foto de un ticket antes de continuar...",
          "info"
        );
        return;
      }

      // if (this.monto < this.monto_minimo) {
      //   swal.fire(
      //     "Oops",
      //     "El monto de tu ticket de compra debe ser de al menos $" +
      //       this.monto_minimo,
      //     "warning"
      //   );
      //   return;
      // }

      // if (this.monto == null) {
      //   swal.fire(
      //     "Oops",
      //     "Llena los campos del formulario antes de continuar...",
      //     "warning"
      //   );
      //   return;
      // }

      //revisar si tiene membresia plus

      if (this.socio_plus == true) {
        if (this.file2 == null) {
          swal.fire(
            "Oops",
            "Sube la foto del frente de tu membresía de socio plus antes de continuar...",
            "info"
          );
          return;
        }

        if (this.file3 == null) {
          swal.fire(
            "Oops",
            "Sube la foto del revés de tu membresía de socio plus antes de continuar...",
            "info"
          );
          return;
        }

        if (this.no_membresia_plus == "") {
          swal.fire(
            "Oops",
            "Ingresa el no. de membresía plus antes de continuar...",
            "info"
          );
          return;
        }

        if (this.no_membresia_plus.toString().length > 17) {
          swal.fire(
            "Oops",
            "La longitud del no. de membresía debe ser de 17 caracteres o menos...",
            "info"
          );
          return;
        }
      }

      if (
        this.userProfile.user_id == "" ||
        this.userProfile.user_id == undefined ||
        this.userProfile.user_id == null
      ) {
        swal.fire(
          "Oops",
          "Ha ocurrido un error en el envío de tu respuesta, por favor recarga la página y vuelve a intentarlo.",
          "warning"
        );
        return;
      }

      let ticket_obj = await this.$store.dispatch("registroTicket", {
        // monto: this.monto,
        //no_ticket: this.no_ticket,
        //no_membresia_plus: this.no_membresia_plus,
        file: this.file,
        // socio_plus: this.socio_plus,
        // file2: this.file2,
        // file3: this.file3,
        // cadena: this.cadena,
        // monto_minimo: this.monto_minimo,
      });

      this.uploadVeryfi(ticket_obj, this.socio_plus);

      this.file = null;
      var preview = document.getElementById("preview");
      preview.innerHTML = "";
    },
    uploadVeryfi(ticket_obj, socio_plus) {
      const https = require("https");
      var qData = {
        img_url: ticket_obj.ticket_img_url,
      };
      this.$http
        .post(process.env.VUE_APP_API_URL + "main.php", JSON.stringify(qData), {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "text/plain",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          async (response) => {
            // get body data
            console.log("VERYFI RESPONSE");
            console.log(response);

            let res = response.body;
            let resactualiza = await this.$store.dispatch(
              "actualizaTicketVeryfi",
              {
                // ticket_ocr: res.response,
                ticket_ocr: "{'invoice_number':'101010101'}",
                ticket_obj: ticket_obj,
                validacion: res.validacion,
                validacion_cinepolis: res.validacion_cinepolis,
                validacion_combo: res.validacion_combo,
                validacion_fecha: res.validacion_fecha,
                invoice_duplicado: res.invoice_duplicado,
                mnms: res.mnms,
                
                //coca_sin_azucar: res.coca_sin_azucar,
                //cashi: res.cashi,
                //socio_plus: this.socio_plus,
              }
            );

            if (resactualiza === "ok") {
              this.$router.push("/dinamica");
            } else {
              swal.fire(
                "Oops",
                "El ticket que has registrado es inválido, verifica los datos de tu ticket e intenta subirlo nuevamente, la foto debe ser nítida y contener el ticket completo no. de ticket, fecha y productos participantes.",
                "warning"
              );
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            swal.fire(
              "Oops",
              "Hubo un error al momento de subir tu ticket, por favor intenta de nuevo.",
              "warning"
            );
            this.$store.dispatch("showLoader", false);
          }
        );
    },
    toggleSucursal() {
      this.overlay_sucursal = !this.overlay_sucursal;
    },
    toggleTransaccion() {
      this.overlay_transaccion = !this.overlay_transaccion;
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }

      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>

<style lang="scss" scoped>
.overlayticket {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100000;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  .bg-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
  }
  .ticket {
    width: 50%;
    margin: 0 25%;
    .head {
      width: 100%;
      .cerrar {
        text-align: right;
        cursor: pointer;
        user-select: none;
      }
    }
    .body {
    }
  }
}
</style>
